import { IExpertUpdateModel } from '../../interfaces/IExpert';
import { useMutation } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useExpertUpdateMutation = () => {
    const { zoneApiClient } = useZoneContext();
    
    return useMutation({
        mutationFn: async (expert: IExpertUpdateModel) => {
            const response = await zoneApiClient.updateExpert(expert);

            if (!response?.httpResponse.ok) {
                throw new Error('Failed to update Expert');
            }

            return response;
        },
    });
}
